import { useState } from 'react';

import useExportButtonWithSpinner from '@/creditflowresearch/application/TopCompanies/useExportButtonWithSpinner';
import { useHeaderMenuContext } from '@/creditflowresearch/application/HeaderMenu/HeaderMenuContext';
import { PARENT_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import {
  useCorporatePeriodsCollection,
} from '@/creditflowresearch/application/TopCompanies/topCompaniesCommonCorporate/useCorporatePeriodsCollection';
import {
  ITopParentsCorporate,
} from '@/creditflowresearch/application/TopCompanies/topCompaniesCommonCorporate/TopCompaniesCommonCorporateContext';
import useCorporateTopCompanyFilters
  from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/useCorporateTopCompanyFilters';
import * as FILTER_TYPES from '@/creditflowresearch/application/PageFiltersState/constants';

export const useTopCompanyCommonCorporate = ({
  periods,
  parent,
  totalCount,
  filters: serverFilters,
}: ITopParentsCorporate) => {
  const filters = useCorporateTopCompanyFilters({ serverFilters });
  const {
    isExportFetching,
    isExportAvailable,
    downloadExcelFile,
    setIsExportAvailable,
  } = useExportButtonWithSpinner(totalCount !== 0);
  const { regions: regionsList, products: productsList } = useHeaderMenuContext();
  const { pageFilters } = usePageFiltersContext();
  const {
    periodsCollection,
    selectedPeriod,
    setSelectedPeriod,
    isPeriodsFetching,
  } = useCorporatePeriodsCollection(periods, serverFilters);
  const [activeTab, setActiveTab] = useState<string>(serverFilters?.includedRole || PARENT_NAME);

  const exportToExcel = () => downloadExcelFile({
    pageFilters: {
      ...pageFilters,
      ...filters,
      getTopCompaniesBy: FILTER_TYPES.INDUSTRY,
    },
    selectedPeriod,
    products: productsList,
    regions: regionsList,
    parentName: parent?.name,
  });

  return {
    isPeriodsFetching,
    periodsCollection,
    setSelectedPeriod,
    selectedPeriod,
    isExportFetching,
    isExportAvailable,
    setIsExportAvailable,
    exportToExcel,
    activeTab,
    setActiveTab,
  };
};
